// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TNi2g","label":"styles_label__sTS56"};